import React from "react";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { timeinputconverter } from "Component/DynamicForm/Fields/Time";
import { DatePickerComponent } from "Component/Custom";
import { getEJ2CalenderDateFormat } from "Utils";
import moment from "moment";
import Button from "@material-ui/core/Button";
import { instance } from "Actions/AxiosInstance";
import { withSnackbar } from "notistack";

const eventtype = [
  {
    displayvalue: 1,
    displayname: "Telephonic interview",
  },
  {
    displayvalue: 2,
    displayname: "Face to face interview",
  },
  {
    displayvalue: 3,
    displayname: "Task",
  },
];

export class ScheduleActivityDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locationtypeids: [
        { displayname: "Remote", displayvalue: 1 },
        { displayname: "Physical", displayvalue: 2 },
      ],
      remotetypeids: [
        { displayname: "Zoom", displayvalue: 1 },
        { displayname: "Google meets", displayvalue: 2 },
        { displayname: "Others", displayvalue: 3 },
      ],
      starttime: "",
      endtime: "",
      selectedCandidate: this.props.selectedCandidate,
      // employeeList: this.props.employeeList,
      // alltimezone: this.props.alltimezone,
      employeeList: [],
      alltimezone: [],
      postData: this.props.activitydata
        ? {
            ...this.props.activitydata,
            activitystartdate: moment(
              this.props.activitydata.activitystart,
            ).format("YYYY-MM-DD"),
            activitystarttime: moment(
              this.props.activitydata.activitystart,
            ).format("H:mm:ss"),
            activityduedate: moment(this.props.activitydata.activitydue).format(
              "YYYY-MM-DD",
            ),
            activityduetime: moment(this.props.activitydata.activitydue).format(
              "H:mm:ss",
            ),
          }
        : {
            candidateid:
              this.props.selectedCandidate &&
              this.props.selectedCandidate.candidateid,
            pipelinestageid:
              (this.props.selectedCandidate && this.props.pipelinestageid) || 1,
            eventtypeid: null, // 1.telephonic 2.Face to face 3. Task
            title: null,
            description: null,
            activitystartdate: null,
            activityduedate: null,
            activityzoneid: 251,
            activitystatusid: 1, // 1.New 2.In Process 3.Done 4.Cancle 5.Not Done
            messagecandidate: null,
            messageparticipants: null,
            locationtypeid: null, // 1.Remote 2.Physical
            remotetypeid: null, // 1.Gmeet 2.Zoom 3.Other
            physaddress: null,
            addparticipant: this.props.addedparticipant || null,
            removeparticipant: null,
            participanttypeid: null,
          },
      selectedParticipants: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.ConvertDate = this.ConvertDate.bind(this);
    this.SelectHireDate = this.SelectHireDate.bind(this);
  }

  SelectHireDate(key, args) {
    const { postData } = this.state;
    postData[key] = this.ConvertDate(args.value);
    this.setState({ postData });
  }

  ConvertDate(str) {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  componentDidMount() {
    this.getActivityInit();
  }

  getActivityInit = () => {
    instance
      .get("recruit/initactivity")
      .then((result) => {
        const response = result.data.result[0];
        const participipants = this.props.addedparticipant || "";
        const employeeList = (response && response.employee) || [];

        let { selectedParticipants } = this.state;

        selectedParticipants = employeeList.filter((employee) =>
          participipants
            .split(",")
            .some((employeeid) => employee.displayvalue == employeeid),
        );

        this.setState({
          employeeList,
          participipants,
          selectedParticipants,
          alltimezone: response && response.alltimezone,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  };

  handleChange(key, value) {
    const { postData } = this.state;
    postData[key] = value;
    this.setState({ postData });
  }

  updateParticipants(arrParticipant) {
    const { postData } = this.state;
    postData.addparticipant = arrParticipant;
    this.setState({
      selectedParticipants: arrParticipant,
      postData,
    });
  }

  onSave = () => {
    const { postData, selectedParticipants } = this.state;
    const { addedparticipant, iscandidateactivityedit } = this.props;

    if (iscandidateactivityedit && addedparticipant) {
      postData.addparticipant = selectedParticipants
        .filter(
          (participant) =>
            !addedparticipant
              .split(",")
              .some(
                (pvsParticipantid) =>
                  pvsParticipantid == participant.displayvalue,
              ),
        )
        .map((participant) => participant.displayvalue)
        .join(",");

      postData.removeparticipant = addedparticipant
        .split(",")
        .filter(
          (pvsParticipantids) =>
            !selectedParticipants.some(
              (participant) => pvsParticipantids == participant.displayvalue,
            ),
        )
        .join(",");
    } else {
      postData.addparticipant = selectedParticipants
        .map((participant) => participant.displayvalue)
        .join(",");
    }

    const backData = JSON.stringify(postData);
    postData.employeeids =
      postData.employeeids &&
      postData.employeeids.map((x) => x.displayvalue).join();
    postData.activitystart = `${postData.activitystartdate} ${postData.activitystarttime}`;
    postData.activitydue = `${postData.activityduedate} ${postData.activityduetime}`;
    if (!postData.eventtypeid) {
      this.props.enqueueSnackbar("Please select event type", {
        variant: "error",
      });
      return;
    } else if (!postData.title) {
      this.props.enqueueSnackbar("Please enter the event title", {
        variant: "error",
      });
      return;
    } else if (!postData.description) {
      this.props.enqueueSnackbar("Please enter event description", {
        variant: "error",
      });
      return;
    } else if (!postData.activitystartdate) {
      this.props.enqueueSnackbar("Please select activity start date", {
        variant: "error",
      });
      return;
    } else if (!postData.activitystarttime) {
      this.props.enqueueSnackbar("Please select activity start time", {
        variant: "error",
      });
      return;
    } else if (!postData.activityduedate) {
      this.props.enqueueSnackbar("Please select activity due date", {
        variant: "error",
      });
      return;
    } else if (!postData.activityduetime) {
      this.props.enqueueSnackbar("Please select activity due time", {
        variant: "error",
      });
      return;
    } else if (!postData.locationtypeid) {
      this.props.enqueueSnackbar("Please select location", {
        variant: "error",
      });
      return;
    } else if (!postData.physaddress) {
      this.props.enqueueSnackbar("Please enter physical address", {
        variant: "error",
      });
      return;
    } else if (!postData.messagecandidate) {
      this.props.enqueueSnackbar("Please enter message to candidate", {
        variant: "error",
      });
      return;
    } else if (!postData.messageparticipants) {
      this.props.enqueueSnackbar("Please enter message to guest", {
        variant: "error",
      });
      return;
    } else if (postData.activityduedate < postData.activitystartdate) {
      this.props.enqueueSnackbar(
        "Activity due date can not be less than activity start date ",
        { variant: "error" },
      );
    } else if (moment(postData.activitystart) > moment(postData.activitydue)) {
      this.props.enqueueSnackbar(
        "Activity due time can not be less than activity start time ",
        {
          variant: "error",
        },
      );
      return;
    } else {
      this.setState({
        isDisableSaveButton: true,
      });
      instance
        .post("recruit/createactivity", { ...postData })
        .then((result) => {
          postData.activityid && this.props.apiCallfun();
          this.props.onCloseDrawer();
          this.props.getData(this.props.carddata);
          this.props.enqueueSnackbar("Saved successfully", {
            variant: "success",
          });
          this.setState({
            isDisableSaveButton: false,
          });
        })
        .catch((error) => {
          this.setState({ postData: JSON.parse(backData) });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
          this.setState({
            isDisableSaveButton: false,
          });
        });
    }
  };

  render() {
    const { postData } = this.state;
    const { employeeList, alltimezone } = this.state;
    return (
      <div>
        <DynamicForm
          fields={selectinputconverter({
            value: postData.eventtypeid,
            placeholder: "",
            label: "Select event type",
            options: eventtype,
          })}
          onChange={(selectedid) => {
            this.handleChange("eventtypeid", selectedid);
          }}
        />
        <DynamicForm
          fields={textinputconverter({
            value: postData.title,
            label: "Enter the event title",
            placeholder: "",
          })}
          onChange={(e) => this.handleChange("title", e)}
        />
        <DynamicForm
          fields={textareainputconverter({
            value: postData.description,
            label: "Enter event description",
            placeholder: "",
          })}
          onChange={(e) => this.handleChange("description", e)}
        />
        <p className="input-label">When does this activity start?</p>
        <DatePickerComponent
          placeholder="Select Date"
          id="startDate"
          allowEdit
          format={getEJ2CalenderDateFormat()}
          value={postData.activitystartdate}
          min={postData.minApplyDate}
          change={(e) => this.SelectHireDate("activitystartdate", e)}
        />
        <div className="margin-top-16">
          <DynamicForm
            fields={timeinputconverter({
              value: postData.activitystarttime,
              label: "Enter start time",
            })}
            onChange={(e) => this.handleChange("activitystarttime", e)}
            formKey="policyname"
          />
        </div>
        <p className="input-label">When is this activity due?</p>
        <DatePickerComponent
          placeholder="Select Date"
          id="endDate"
          allowEdit
          format={getEJ2CalenderDateFormat()}
          value={postData.activityduedate}
          min={postData.minApplyDate}
          change={(e) => this.SelectHireDate("activityduedate", e)}
        />
        <div className="margin-top-16">
          <DynamicForm
            fields={timeinputconverter({
              value: postData.activityduetime,
              label: "Enter end time",
            })}
            onChange={(e) => this.handleChange("activityduetime", e)}
            formKey="policyname"
          />
        </div>
        <DynamicForm
          fields={selectinputconverter({
            value: postData.activityzoneid,
            placeholder: "",
            label: "Select effective time zone",
            options: alltimezone || [],
          })}
          onChange={(selectedid) => {
            this.handleChange("activityzoneid", selectedid);
          }}
        />
        <DynamicForm
          fields={selectinputconverter({
            value: postData.locationtypeid,
            placeholder: "",
            label: "Location",
            options: this.state.locationtypeids || [],
          })}
          onChange={(selectedid) => {
            this.handleChange("locationtypeid", selectedid);
          }}
        />

        {postData.locationtypeid == 1 && (
          <DynamicForm
            fields={selectinputconverter({
              value: postData.remotetypeid,
              placeholder: "",
              label: "Remote App",
              options: this.state.remotetypeids || [],
            })}
            onChange={(selectedid) => {
              this.handleChange("remotetypeid", selectedid);
            }}
          />
        )}
        <DynamicForm
          fields={textareainputconverter({
            value: postData.physaddress,
            label:
              postData.locationtypeid == 1
                ? "Remote address"
                : "Physical address",
            placeholder: "",
          })}
          onChange={(event) => {
            this.handleChange("physaddress", event);
          }}
        />
        <div>
          <DynamicForm
            fields={multiselectinputconverter({
              value: this.state.selectedParticipants,
              label: "Add participants ",
              placeholder: "",
              options: employeeList || [],
            })}
            onChange={(ids) => {
              this.updateParticipants(ids);
            }}
          />
        </div>
        <DynamicForm
          fields={textareainputconverter({
            value: postData.messagecandidate,
            label: "Message to candidate",
            placeholder: "",
          })}
          onChange={(e) => this.handleChange("messagecandidate", e)}
        />
        <DynamicForm
          fields={textareainputconverter({
            value: postData.messageparticipants,
            label: "Message to participant(s)",
            placeholder: "",
          })}
          onChange={(e) => this.handleChange("messageparticipants", e)}
        />
        <div style={{ padding: "24px 0px" }}>
          <Button
            className="btn btn-primary-md-blue"
            variant="contained"
            onClick={() => this.onSave()}
            disabled={this.state.isDisableSaveButton}
          >
            Schedule activity
          </Button>
        </div>
      </div>
    );
  }
}

export default withSnackbar(ScheduleActivityDrawer);
